module.exports = __webpack_public_path__ + "img/032-choice.2186b2e8.svg";